import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'


Vue.use(Router)

export default new Router({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if(savedPosition) {
      console.log(savedPosition)
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js